import { User } from "domain/entities/user";
import { Result } from "domain/entities/result";
import { UserRepository } from "domain/repositories";

export default class UpdateUseCase {
    private userRepository: UserRepository;
    
    public constructor(userRepository: UserRepository) {
        this.userRepository = userRepository
    }

    public async updateUser(id: number, user: User, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.userRepository.updateUser(id, user, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}